<template>
  <div id="app">
    <div id="my_contents">
      <div class="header">
        <Header />
      </div>
      <div id="game_content">
        <Contents />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./components/HeaderView.vue"
import Contents from "./components/ContentsView.vue"

export default {
  name: "App",
  components: {
    Header,
    Contents
  },
  created () {
    window.addEventListener("resize", this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    /**
     * 現在の画面サイズの保存
     */
    handleResize () {
      // console.log("Screen resized")
      this.$store.dispatch('setCurrentScreenSize', { width: window.innerWidth, height: window.innnerHeight })
    }
  }
}
</script>

<style lang="sass" src='./assets/common_style.sass'></style>
<style lang="sass" scoped>
@import url('https://fonts.googleapis.com/css?family=M+PLUS+Rounded+1c:500,800|Sawarabi+Gothic')
@import url('https://fonts.googleapis.com/css?family=Kosugi+Maru&amp;subset=japanese')

#app
  font-family: sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #29292A
  height: 100vh
  height: 100%


#my_contents
  display: flex
  flex-direction: column
  height: 100vh
  height: 100%
  top: 0
  width: 100%

.header
  z-index: 100

#game_content
  flex: auto
  position: relative

#footer
  background-color: #efeff4
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center
  flex-wrap: wrap
  min-height: 60px

</style>
